import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useMapStore } from '../../store/mapStore';

const StatsPanel = () => {
  const { exploredLocations, getFilteredLocations } = useMapStore();
  const filteredCount = getFilteredLocations().length;
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="absolute top-4 right-4 z-[1000]">
      {/* Toggle Button */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="bg-copper text-parchment-base p-3 rounded-lg shadow-lg hover:bg-gold transition-all border-2 border-ink-primary mb-2 float-right"
        aria-label="Toggle statistics panel"
      >
        <span className="text-xl">
          {isExpanded ? '▶' : '◀'}
        </span>
      </button>

      {/* Expandable Panel */}
      <AnimatePresence>
        {isExpanded && (
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.3 }}
            className="bg-parchment-base border-2 border-copper rounded-lg p-4 shadow-lg min-w-[250px] clear-right"
          >
            <h3 className="font-display text-xl text-ink-primary mb-4 text-center">Journey Statistics</h3>
            <div className="space-y-3 text-center">
              <div className="parchment-card p-3">
                <div className="text-3xl font-display text-gold">{exploredLocations.size}/17</div>
                <div className="text-sm font-ui text-ink-secondary mt-1">Locations Explored</div>
              </div>
              <div className="parchment-card p-3">
                <div className="text-3xl font-display text-copper">{filteredCount}</div>
                <div className="text-sm font-ui text-ink-secondary mt-1">Visible Locations</div>
              </div>
              <div className="parchment-card p-3">
                <div className="text-2xl font-display text-sea-dark">~4,000</div>
                <div className="text-sm font-ui text-ink-secondary mt-1">Nautical Miles</div>
              </div>
              <div className="parchment-card p-3">
                <div className="text-2xl font-display text-ink-primary">10 Years</div>
                <div className="text-sm font-ui text-ink-secondary mt-1">Away from Home</div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default StatsPanel;
